import { useMemo } from 'react';
import type { LngLat } from '../../types/Geo';
import { decodeSegmentLatLng, reverseCoord } from '../../utils/legacyGeoJSONConversions';
import { Polylines } from '../Polyline';

type HoveredActivityPolylinesProps = {
  encodedPolyline?: string;
};

const HoveredActivityPolylines = ({ encodedPolyline }: HoveredActivityPolylinesProps) => {
  const polylines = useMemo(() => {
    if (!encodedPolyline) return [];
    const coordinates = decodeSegmentLatLng({ polyline: { pointsData: encodedPolyline } }).map(coord => reverseCoord(coord)) as LngLat[];
    return [{ coordinates, properties: {} as Record<string, unknown> }];
  }, [encodedPolyline]);

  return <Polylines polylines={polylines} uniqueId="hovered-activity-polylines" />;
};

export default HoveredActivityPolylines;
